import React, { useEffect, useState } from 'react';
import DataTable from '../../components/UI/table';
import { PHSHeader } from '../../components/UI/header';
import { styles } from './index.sass';
import { Button, Modal, Select, message } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { addAdmin, getClients, getExperts, softDeleteUser } from '../../api';
import { roleLevel } from '../../utils';

const { Option } = Select;

export const Admins = () => {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState([]);
    const [selectedClientId, setSelectedClientId] = useState(null);
    const [showAddAdminModal, setShowAddAdminModal] = useState(false);

    const fetchadmins = async () => {
        setLoading(true);
        const data = await getExperts();
        setAdmins(data.experts.map((admin) => {
            return {
                ...admin,
                admin_id: admin.id,
                admin_name: admin.full_name
            }
        }) || []);
        setLoading(false);
    }

    const fetchAllClients = async () => {
        const data = await getClients();
        setClients(data.clients.filter(client => client.role !== roleLevel.Expert) || []);
    }

    const onClickAddAdmin = () => {
        const data = addAdmin({
            client_id: selectedClientId
        });
        setSelectedClientId(null);
        setShowAddAdminModal(false);
        setTimeout(() => {
            fetchadmins();
            message.success('Admin added successfully');
        }, 2000);
    }

    const onClickDeleteAdmin = async (adminId) => {
        setLoading(true);
        const data = await softDeleteUser({
            client_id: adminId
        });
        fetchadmins();
        message.success('Admin deleted successfully');
    }

    useEffect(() => {
        fetchadmins();
        fetchAllClients();
    }, []);

    const columns = [
        { title: 'Admin Id', dataIndex: 'admin_id', key: 'admin_id' },
        { title: 'Admin Name', dataIndex: 'admin_name', key: 'admin_name' },
        {
            key: 'actions',
            title: 'Actions',
            render: (text, record) => {
                return (
                    <div>
                        <Button type="default" onClick={() => onClickDeleteAdmin(record.id)}>
                            <DeleteOutlined style={{ color: 'red' }} />
                        </Button>
                    </div>
                )
            }
        }
    ];

    return (
        <div className={styles}>
            <PHSHeader
                hideBreadCrumb={true}
                hideSubHeader={true}
            />
            <div className='container'>
                <div className='flex'>
                    <h2>Admins ({admins.length})</h2>
                    <div>
                        <Button type="default" onClick={() => setShowAddAdminModal(true)}>
                            <PlusOutlined />
                        </Button>
                    </div>
                </div>
                <div>
                    <DataTable
                        columns={columns || []}
                        dataSource={admins || []}
                        loading={loading}
                        hidePagination={true}
                    />
                </div>
                <Modal
                    open={showAddAdminModal}
                    onCancel={() => setShowAddAdminModal(false)}
                    onOk={onClickAddAdmin}
                >
                    <div>
                        <div>Add Service Provider</div>
                        <div>
                            <div>Select Provider</div>
                            <Select
                                style={{ width: '100%' }}
                                showSearch
                                defaultValue={[]}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(selectedClient) => {
                                    setSelectedClientId(parseInt(selectedClient));
                                }}
                            >
                                {clients.map((client) => {
                                    return (
                                        <Option key={client.id} value={client.id}>{client.full_name}</Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}